import {
  Component,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

import { Detail, SortedArticles } from '../services/faq.interface';
import { FaqService } from '../services/faq.service';

@Component({
  selector: 'app-faq-content',
  templateUrl: './faq-content.component.html',
  styleUrls: ['./faq-content.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-5%)', opacity: 0 }),
        animate('200ms', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('200ms', style({ transform: 'translateY(-5%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class FaqContentComponent implements OnChanges, OnInit {
  constructor(private faqService: FaqService) {}

  @Input() category = '';
  @Input() blockNumber = 0;
  @Input() activeBlockNumber = 0;
  @Input() setBlockNumber: (num: number) => void;
  @Input() articles: SortedArticles | null = null;
  @Input() categories: string[] | null = null;

  @Output() blockNumberEvent = new EventEmitter<number>();

  isActive = false;
  childContent = 0;
  attachmentCache: { [id: string]: any } = {};

  ngOnInit(): void {
    if (this.categories?.length && this.articles && this.category) {
      this.articles[this.category].forEach((element) => {
        element.details.forEach((detail) => {
          const isPicture = this.isPictureAndIsIdNumber(detail);
          if (isPicture) {
            this.getAttachmentByIdMethod(detail.value);
          }
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.activeBlockNumber.currentValue === this.blockNumber) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    }
  }

  setBlockNumberHandler(num: number): void {
    if (this.isActive) {
      this.blockNumberEvent.emit(0);
    } else {
      this.blockNumberEvent.emit(num);
    }
  }

  setChildContent(idx: number, isCurrent: boolean): void {
    if (isCurrent) {
      this.childContent = 1000;
    } else {
      this.childContent = idx;
    }
  }

  getAttachmentByIdMethod(id: string): void | string{
    if (this.attachmentCache[id]) {
      return this.attachmentCache[id];
    }

    this.faqService.getAttachmentById(Number(id)).subscribe((val) => {
      this.attachmentCache[id] = val.body;
    });

    return null;
  }

  isPictureAndIsIdNumber(detail: Detail): boolean {
    const id = Number(detail.value);
    const type = detail.detailType.code === 'picture';
    return type && Boolean(id);
  }
}
